import React from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import theme from "@/theme";
import { styles } from "./stylesLeaderboardHeader";

const LeaderboardHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type") || "Leaderboard";

  const handleTabClick = (tab: "Leaderboard" | "Top-100") => {
    navigate(`/leaderboard?type=${tab}`);
  };

  return (
    <Box component="header" position="static" sx={styles.appBar} color="default">
      <Box sx={styles.appBarContainer}>
        <Typography
          variant="subtitle1"
          sx={{
            color: theme.palette.custom.blueGray900,
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "24px",
            letterSpacing: 0,
          }}
        >
          Leaderboard
        </Typography>

        <Tabs
          variant="scrollable"
          value={type}
          onChange={(_, newValue) => handleTabClick(newValue as "Leaderboard" | "Top-100")}
          sx={styles.tabsNavigation}
          TabIndicatorProps={{ sx: styles.tabsNavigationIndicator }}
        >
          <Tab
            sx={() => styles.tabsNavigationTab({ selected: type === "Leaderboard" })}
            label="Leaderboard"
            value="Leaderboard"
          />
          <Tab
            sx={() => styles.tabsNavigationTab({ selected: type === "Top-100" })}
            label="Top 100 earners"
            value="Top-100"
          />
        </Tabs>
      </Box>
    </Box>
  );
};

export default LeaderboardHeader;
